import React, { useState } from 'react';
import DataTableCustom from './DataTableCustom';
import { MDBBtn, MDBIcon, MDBInput, MDBRow } from 'mdb-react-ui-kit';
import styled from '@emotion/styled';
import AddItemModal from '../settings/AddItemModal';
import SelectCustom from './SelectCustom';
import { NumericFormat } from 'react-number-format';

export const optionsMonth = [
  { value: 'ene', label: 'Enero' },
  { value: 'feb', label: 'Febrero' },
  { value: 'mar', label: 'Marzo' },
  { value: 'abr', label: 'Abril' },
  { value: 'may', label: 'Mayo' },
  { value: 'jun', label: 'Junio' },
  { value: 'jul', label: 'Julio' },
  { value: 'agt', label: 'Agosto' },
  { value: 'sep', label: 'Septiembre' },
  { value: 'oct', label: 'Octubre' },
  { value: 'nov', label: 'Noviembre' },
  { value: 'dic', label: 'Diciembre' },
]

const StyleRow = styled(MDBRow)`
  margin: 0 10px;
`;

interface IPropsForm {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  typeAction: {typeName?: string, option?: string, data?: any }
  handleSave: any;
  dataForm: any[];
}

interface IProps {
  columns: any[];
  headers: any[];
  dataDefault: any[];
  handleSaveContactos: any;
}
let idValue = 1;

const AddNewForm = ({showModal = false, setShowModal, typeAction, handleSave, dataForm = [] }: IPropsForm) => {
  const [formValue, setFormValue] = useState(typeAction?.data || {})

  const handleSaveData = () => {
    const {option} = typeAction
    console.log("++ formValue: ", formValue)
console.log("sssave > ", {option, data: {...formValue, id: formValue?.id || idValue++} })
    handleSave(option,  {...formValue, id: formValue?.id || idValue++})
    setShowModal(!showModal)
  }

  const onChange =(e: any) => {
    console.log("e > ", e)
    const { name, value } = e.target

    setFormValue({ ...formValue, [name]: value });
  }

  const onChangeSelect = (data: any) => {
    const { name, value } = data
    onChange({target: {name, value}})
  }

  const contentForm = () => {
    const { month, ano, monto } = formValue
    return (
      <>
        <div className="d-flex">
          <div className="p-2 w-50">
            <SelectCustom options={optionsMonth} onChangeSelect={onChangeSelect} name='month' defaultValue={month || ""} required /></div>
          <div className="p-2 w-50">
            
          <MDBInput label="ano" type='text' name='ano' value={ano || "2024"} onChange={onChange} required />
          </div>
        </div>
        <div className="p-2 w-100 text-start">
          Monto
        <NumericFormat 
          value={monto || 0} 
          onValueChange={(values: any) => onChange({target: {name:"monto", value: values.value}})}
          thousandSeparator={true}
          valueIsNumericString={true}
          allowNegative={false}
          customInput={MDBInput}
          prefix="$"
          style={{ fontSize: '16px'}}
        />
        </div>

      </>
    )
  }

  return (
    <AddItemModal keyModal="modal-facturacion" sizeModa='sm' typeAction={typeAction} showModal={showModal} setShowModal={setShowModal} handleSave={handleSaveData} centeredDialog >
      { contentForm() }
    </AddItemModal>
  )
}

const DatosFacturacionDataTable = ({ columns, headers, dataDefault, handleSaveContactos }: IProps) => {
  const [showModal, setShowModal] = useState(false);
  const [typeAction, setTypeAction] = useState({})

  const handlItemAction = (typeName: string, option: string, data?: any) => {
    setShowModal(true);
    setTypeAction({ typeName, option, data })
  }

  const handleSave = async(option: string, data: any) => {
    console.log("handleSave > data: ", data)
    const newData = (option === 'Nuevo') ? 
                    [...dataDefault, data] : 
                    dataDefault.map((items) => items.id === data.id ? data : items )
console.log("newData-Save > ", newData)
    handleSaveContactos({name: 'factura', value: newData})
  }

  const actionsDataTable = (data: any) => {
    return (
      <>
        <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#3b5998' }} onClick={() => handlItemAction("configuracion", "Edit", data)} >
        <MDBIcon fas icon='edit' size='sm' />
        </MDBBtn>

        <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#3b5998' }}>
        <MDBIcon fas icon='trash' size='sm' />
        </MDBBtn>
      </>
    )
  }

  return (
    <>
      <StyleRow end>
        <MDBBtn className='ms-2' tag='a' color='secondary' floating  
          onClick={() => {

            handlItemAction("configuracion", "Nuevo")
          }} >
          <MDBIcon fas icon='plus' size='sm' />
        </MDBBtn>
      </StyleRow>  
      <DataTableCustom 
        keyDataTable="table-contactos" 
        columns={[
          ...columns, 
          {
            name: "",
            button: true,
            cell: (row: any) => actionsDataTable(row),
            right: true
          }
        ]} 
        data={dataDefault} 
      />
      {showModal && <AddNewForm showModal={showModal} setShowModal={setShowModal} typeAction={typeAction} handleSave={handleSave} dataForm={headers} ></AddNewForm>}
    </>
  );
}

export default DatosFacturacionDataTable;
